import React from 'react'
import { withTranslation } from 'react-i18next';

const Adresse = (props) => {
    var adresse = props.adresse;
    var gatenavn = adresse.gatenavn;
    if (adresse.husnrbokstav) gatenavn += ' ' +adresse.husnrbokstav
    return(
        <li className="resultitem" onClick={() => props.onSelectResult(adresse)}>
            <div className="title">{adresse.kommunenavn} ({props.t('adresse')})</div>
            <div>{gatenavn}, {adresse.postnavn}</div>
            <div>{props.t('kommune')}: {adresse.kommunenavn}</div>
        </li>
    )
  }

export default withTranslation('common')(Adresse)